import { render, staticRenderFns } from "./AddDistricts.vue?vue&type=template&id=33a25432&scoped=true&"
import script from "./AddDistricts.vue?vue&type=script&lang=js&"
export * from "./AddDistricts.vue?vue&type=script&lang=js&"
import style0 from "./AddDistricts.vue?vue&type=style&index=0&id=33a25432&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a25432",
  null
  
)

component.options.__file = "AddDistricts.vue"
export default component.exports